import httpService from "./httpService";
import EnvConfig from "../utils/config";

class QrAdminService {
  constructor() {
    this.baseUrl = "/eventos";
  }

  /**
   * Obtiene la lista de invitados confirmados con correo para el escaneo QR
   * @param {string} eventoId - ID del evento
   * @returns {Promise<Object>}
   */
  async obtenerInvitadosQR(eventoId) {
    try {
      if (!eventoId) throw new Error("ID del evento requerido");

      const response = await httpService.get(
        `${this.baseUrl}/${eventoId}/seleccion-mesas/invitados-qr`
      );

      return {
        success: true,
        data: response.data,  // response = { success, data, message } from API
      };
    } catch (error) {
      if (EnvConfig.DEBUG_MODE) {
        console.error("Error al obtener invitados QR:", error);
      }
      return {
        success: false,
        error: error.userMessage || "Error al obtener invitados",
      };
    }
  }

  /**
   * Registra el escaneo de boletos
   * @param {string} eventoId - ID del evento
   * @param {string} invitadoId - ID del invitado
   * @param {number} boletos - Cantidad de boletos a escanear
   * @returns {Promise<Object>}
   */
  async registrarEscaneoQR(eventoId, invitadoId, boletos) {
    try {
      if (!eventoId || !invitadoId) throw new Error("Datos requeridos incompletos");
      if (!boletos || boletos <= 0) throw new Error("Cantidad de boletos inválida");

      const response = await httpService.post(
        `${this.baseUrl}/${eventoId}/seleccion-mesas/escaneo-qr`,
        {
          invitado_id: invitadoId,
          boletos_a_escanear: boletos
        }
      );

      return {
        success: true,
        data: response.data,  // response = { success, data, message } from API
      };
    } catch (error) {
      if (EnvConfig.DEBUG_MODE) {
        console.error("Error al registrar escaneo:", error);
      }
      return {
        success: false,
        error: error.userMessage || error.data?.error || "Error al registrar escaneo",
      };
    }
  }
}

const qrAdminService = new QrAdminService();
export default qrAdminService;
